var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"c-navbar__logo",attrs:{"to":{ name: _vm.RouteName.HOME }}},[_c(_vm.logoTag,{tag:"component",staticClass:"u-visually-hidden"},[_vm._v(" "+_vm._s(_vm.tenantLogoAlt)+" ")]),_c('img',{attrs:{"alt":_vm.tenantLogoAlt,"src":_vm.tenantLogoSrc}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }